export const REPORT_TYPE_PREVEN = 0;
export const REPORT_TYPE_NEWBORN = 1;
export const REPORT_TYPE_BRCA = 2;
export const REPORT_TYPE_PROSTATEGENE = 4;
export const REPORT_TYPE_NIPT = 5;
export const REPORT_TYPE_PHARMACOGENOMICS = 6;

export const REPORT_STATUS_REMOVED = 0;
export const REPORT_STATUS_AVAILABLE = 1;
export const REPORT_STATUS_DOWNLOADED = 2;

export const REPORTS_TYPES_LABEL = {
  [parseInt(REPORT_TYPE_PREVEN, 10)]: "PrevenTest",
  [parseInt(REPORT_TYPE_NEWBORN, 10)]: "Newborn GeneID",
  [parseInt(REPORT_TYPE_BRCA, 10)]: "BRCA Test",
  [parseInt(REPORT_TYPE_PROSTATEGENE, 10)]: "ProstateGene ID",
  [parseInt(REPORT_TYPE_NIPT, 10)]: "Envisage NIPT",
  [parseInt(REPORT_TYPE_PHARMACOGENOMICS, 10)]: "Pharmacogenomics Test",
};

export const REPORTS_TYPES_LIST = Object.keys(REPORTS_TYPES_LABEL).map(
  (value) => ({ label: REPORTS_TYPES_LABEL[value], value: parseInt(value, 10) })
);

export const REPORTS_STATUS_LABEL = {
  [parseInt(REPORT_STATUS_REMOVED, 10)]: "Removed",
  [parseInt(REPORT_STATUS_AVAILABLE, 10)]: "Available",
  [parseInt(REPORT_STATUS_DOWNLOADED, 10)]: "Available",
};



// WEBPACK FOOTER //
// ./src/constants/reports.js